import * as React from 'react'

import { Box, Title } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import i18n from 'modules/core/lib/i18n'

import { CalendarSyncsList } from 'modules/cronofy/components/CalendarSyncsList'
import { InviteUserButton } from 'modules/cronofy/components/InviteUserButton'

export const CalendarSync = () => {
  const { featureAvailability } = useFeatureAvailability(Features.ats_interview_scheduling)
  if (!featureAvailability?.available) return null

  return (
    <Box paddingTop="s48">
      <Title
        variant="500"
        title={i18n.t('ats.settings.integrations.calendar_synchronization.title')}
        description={i18n.t('ats.settings.integrations.calendar_synchronization.description')}
      >
        <InviteUserButton />
      </Title>
      <HelpCenterLink name="ats_calendar_sync">
        {i18n.t('ats.settings.integrations.calendar_synchronization.link')}
      </HelpCenterLink>
      <CalendarSyncsList />
    </Box>
  )
}
